// imports section Start
import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { useStyles } from "../../../../assets/styles/Theme";
import { Box, Typography, Paper } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
// imports section End

// Styles start
const Item = styled(Paper)(({ theme }) => ({
  // padding: theme.spacing(1),
  textAlign: "left",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  backgroundColor: theme.palette.input_field.fill,
  width: "100%",
  // height: "5vh",
  padding: 0,
  px: 2,
  my: 2,
}));

const Search = styled("div")(({ theme }) => ({
  color: theme.palette.input_field.text,
  position: "relative",
  borderRadius: "100px",
  // height: "5vh",
  //   boxShadow: 2,
  backgroundColor: theme.palette.input_field.fill,
  "&:hover": {
    backgroundColor: theme.palette.input_field.fill,
  },
  // marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
  alignSelf: "center",
  display: "flex",
  alignContent: "center",
  border: `1px solid ${theme.palette.input_field.stroke}`,
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  color: theme.palette.input_field.text,
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: theme.palette.input_field.text,
  borderRadius: "8px",
  height: "100%",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,

    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));
// styles end
export default function CashierSearchMobile({ handleSearch, showSearch }) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPNAME } = SYS_USER.USER_PARAM || {};

  // Handlers start

  // Handlers end

  return (
    <>
      <Box sx={styles.m_header_grid_container}>
        <Item sx={{ px: 2, py: 1, width: "100%" }}>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Search>
        </Item>
        {/* <Grid container spacing={2}>
          {showSearch && (
            <Grid
              xs={12}
              sm={6}
              md={6}
              lg={4}
              xl={4}
              sx={styles.header_search_pr}
            ></Grid>
          )}
        </Grid> */}
      </Box>
    </>
  );
}
